var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector40(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.856 1.428C22.856 2.22 22.216 2.856 21.428 2.856H1.428C0.636 2.856 0 2.216 0 1.428C0 0.64 0.64 0 1.428 0H21.428C22.22 0 22.856 0.64 22.856 1.428ZM13.808 17.144H9.048C8.256 17.144 7.62 17.784 7.62 18.572C7.62 19.36 8.26 20 9.048 20H13.808C14.6 20 15.236 19.36 15.236 18.572C15.236 17.784 14.596 17.144 13.808 17.144ZM17.616 8.572H5.24C4.448 8.572 3.812 9.212 3.812 10C3.812 10.788 4.452 11.428 5.24 11.428H17.62C18.412 11.428 19.048 10.788 19.048 10C19.048 9.212 18.408 8.572 17.62 8.572H17.616Z",
    fill: "#ED4C28"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector40);
export default __webpack_public_path__ + "static/media/Vector (40).094064965bac01f9b81b9ce078e98f96.svg";
export { ForwardRef as ReactComponent };